(function(){
var H_MIN=22,H_MAX=56,STEP=0.64,BASE=36.7;
var circOf=function(h){return BASE+STEP*h};
var ukLabel=function(h){var k=Math.floor(h/2),half=h%2?'½':'';return (k<=25?String.fromCharCode(65+k):'Z+'+(k-25))+half};
var usOf=function(c){var n=(c/Math.PI-11.63)/0.8128;return Math.round(n*2)/2};
var STOCK=[{h:32,us:8,eu:57},{h:34,us:9,eu:59},{h:40,us:10,eu:62},{h:44,us:11,eu:65}];
var state={c:59,band:1,knuckle:0};
var $=function(id){return document.getElementById(id)};
function clamp(v,a,b){return Math.min(b,Math.max(a,v))}
var tbody=$('rows');
for(var h=H_MIN;h<=H_MAX;h++){
var tr=document.createElement('tr');
tr.dataset.h=h;
var c=circOf(h);
tr.innerHTML='<td>'+ukLabel(h)+'</td><td>'+usOf(c)+'</td><td>'+Math.round(c)+'</td><td>'+c.toFixed(1)+'</td>';
tbody.appendChild(tr);
}
function render(){
var c=state.c;
var adj=c+(state.band===2?0.64:0)+(state.knuckle?0.64:0);
var h=clamp(Math.round((adj-BASE)/STEP),H_MIN,H_MAX);
var cs=circOf(h);
$('uk').textContent=ukLabel(h);
$('us').textContent=usOf(cs);
$('eu').textContent=Math.round(cs);
$('mm').textContent=cs.toFixed(1);
var best=STOCK[0];
STOCK.forEach(function(x){if(Math.abs(circOf(x.h)-cs)<Math.abs(circOf(best.h)-cs)-0.01||(Math.abs(Math.abs(circOf(x.h)-cs)-Math.abs(circOf(best.h)-cs))<=0.01&&x.h>best.h))best=x});
var label='US '+best.us+' / UK '+ukLabel(best.h)+' / EU '+best.eu;
$('pick').textContent=label;
var d=circOf(best.h)-cs;
$('pickNote').textContent=Math.abs(d)<=0.7?'This is the closest match to your measurement.'
:(d>0?'This is the nearest size up. Your size sits between ARMR sizes, so the ring sizer will help you check the fit.'
:'This is the nearest size down. Your size sits between ARMR sizes, so the ring sizer will help you check the fit.');
var outside=c<circOf(STOCK[0].h)-1.9||c>circOf(STOCK[3].h)+1.9;
if(outside)$('pickNote').textContent='Your size is outside the sizes our rings are made in. The ring sizer is the best place to start.';
var R=window.RG||{},btn=$('btn');
if(!outside&&R.base&&(R.stock||[]).indexOf(label)>-1){
var TAX={Q:3080,R:3081,U:3083,W:3085},tid=TAX[ukLabel(best.h)];btn.href=tid?R.base+'?filter.v.t.shopify.ring-size='+encodeURIComponent('gid://shopify/TaxonomyValue/'+tid):R.base;
btn.textContent='Shop rings in your size';
$('btnNote').textContent='Shows the rings we have in '+label+'.';
}else{
btn.href='/products/armr-ring-sizer';
btn.textContent='Order the ARMR ring sizer';
$('btnNote').textContent='Not sure of your size? The ring sizer is a set of real rings you try on at home.';
}
Array.prototype.forEach.call(tbody.children,function(r){r.classList.toggle('rg-hit',+r.dataset.h===h)});
var cr=$('circ'),crr=$('circR'),dr=$('dia'),drr=$('diaR');
if(document.activeElement!==cr)cr.value=c.toFixed(1).replace('.0','');
crr.value=c;
var dia=c/Math.PI;
if(document.activeElement!==dr)dr.value=dia.toFixed(1);
drr.value=dia.toFixed(1);
drawCircle(dia);
}
var pxPerMm=323/85.6;
function drawCircle(dia){
var r=Math.max(2,dia*pxPerMm/2);
var size=Math.ceil(r*2+12);
var svg=$('svg');
svg.setAttribute('width',size);svg.setAttribute('height',size);
svg.setAttribute('viewBox','0 0 '+size+' '+size);
var c=$('circle');c.setAttribute('cx',size/2);c.setAttribute('cy',size/2);c.setAttribute('r',r);
svg.lastElementChild.setAttribute('cx',size/2);svg.lastElementChild.setAttribute('cy',size/2);
}
function setC(v){if(isFinite(v)){state.c=clamp(Math.round(v*100)/100,46,78);render()}}
$('circ').addEventListener('input',function(e){var v=parseFloat(e.target.value);if(v>=46&&v<=78)setC(v)});
$('circ').addEventListener('change',function(){render()});
$('circR').addEventListener('input',function(e){setC(parseFloat(e.target.value))});
$('dia').addEventListener('input',function(e){var v=parseFloat(e.target.value);if(v>=14.5&&v<=25)setC(v*Math.PI)});
$('dia').addEventListener('change',function(){render()});
$('diaR').addEventListener('input',function(e){setC(parseFloat(e.target.value)*Math.PI)});
$('cardR').addEventListener('input',function(e){
var w=+e.target.value;$('card').style.width=w+'px';pxPerMm=w/85.6;drawCircle(state.c/Math.PI);
});
function group(id,key){
var g=$(id);
g.addEventListener('click',function(e){
var b=e.target.closest('.rg-opt');if(!b)return;
Array.prototype.forEach.call(g.children,function(x){x.setAttribute('aria-pressed',x===b)});
state[key]=+b.dataset.v;render();
});
}
group('band','band');group('knuckle','knuckle');
function tab(sel){
['finger','ring'].forEach(function(n){
var on=n===sel;
$('t-'+n).setAttribute('aria-selected',on);
$('p-'+n).hidden=!on;
});
}
$('t-finger').addEventListener('click',function(){tab('finger')});
$('t-ring').addEventListener('click',function(){tab('ring')});
render();
})();